import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {PageMeta} from '../../../../../model/pagination/page-meta.model';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'ui-search',
    templateUrl: './ui-search.component.html',
    styleUrls: ['./ui-search.component.scss'],
    standalone: false
})
export class UiSearch implements OnInit {
    _focused: boolean = false;
    @Input() loading: boolean;
    @Input() placeholder: string = 'Buscar...';
    @Output('search') searchOutput = new EventEmitter<string>();

    constructor(
        private fb: FormBuilder
    ) {
        this._search = this.fb.control('');
    }

    _pageMeta: PageMeta;

    @Input()
    get pageMeta(): PageMeta {
        return this._pageMeta;
    }

    set pageMeta(pageMeta: PageMeta) {
        this._pageMeta = pageMeta;
        if (this._pageMeta) {
            this._search.setValue(this._pageMeta.search || '', {emitEvent: false});
        }
    }

    _search: FormControl;

    @Input()
    get search() {
        return this._search.value;
    }

    set search(value: string) {
        this._search.setValue(value, {emitEvent: false});
        this.searchOutput.emit(value);
    }

    get hasValue(): boolean {
        return this._search?.value.trim().length > 0 && !this._focused;
    }

    @HostBinding('class') get hostClasses(): string {
        const classes = [
            this.loading ? 'loading' : '',
        ];

        return classes.filter(Boolean).join(' ');
    }

    ngOnInit() {
        this._search.valueChanges
            .pipe(
                debounceTime(500),
                distinctUntilChanged()
            ).subscribe(async (v: string) => {
            if (this.pageMeta) {
                this.pageMeta.page = 0;
                this.pageMeta.search = v.trim();
            }

            this.searchOutput.emit(v.trim());
        });
    }
}
